import { render, staticRenderFns } from "./TaskCheckButton.vue?vue&type=template&id=64d72b48&"
import script from "./TaskCheckButton.vue?vue&type=script&lang=js&"
export * from "./TaskCheckButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports